import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router';
import { Container } from 'react-bootstrap';
import Footer from '../../components/Footer';
import HeaderLocation from '../../components/Header';
import login from '../../store/actions/user.actions';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';

class Perfil extends Component {
  constructor() {
    super();
    this.state = {
      routeTo: null,
    };

    this.setRoute = this.setRoute.bind(this);
  }

  setRoute(route) {
    this.setState({ routeTo: route });
  }

  render() {
    const { routeTo } = this.state;
    if (routeTo) return <Redirect push to={ routeTo } />;

    const { email, setEmail } = this.props;
    const userEmailLocalStorage = JSON.parse(localStorage.getItem('user'));
    const displayEmail = (userEmailLocalStorage && userEmailLocalStorage.email) || email || 'gourmet@kitchenmemories.com';

    return (
      <div className="page-wrapper-custom">
        <HeaderLocation title="Perfil" />
        <Container>
          <div className="search-bar-card mx-auto my-5 p-5 text-center" style={{ maxWidth: '600px' }}>
            <div
              style={{
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, var(--color-primary), var(--color-secondary))',
                color: '#fff',
                fontSize: '2.5rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 16px auto',
                boxShadow: '0 8px 24px rgba(232, 163, 35, 0.3)'
              }}
            >
              👨‍🍳
            </div>
            <h3 style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: '1.6rem', color: 'var(--color-text)' }}>
              Chef de Cozinha
            </h3>
            <h6
              className="email my-2 text-muted fw-semibold"
              data-testid="profile-email"
              style={{ fontSize: '1.05rem' }}
            >
              {displayEmail}
            </h6>

            <div className="d-flex flex-column gap-3 mt-4 pt-4 border-top">
              <button
                type="button"
                data-testid="profile-done-btn"
                onClick={ () => this.setRoute('/receitas-feitas') }
                className="filter-button orange w-100 py-3 d-flex align-items-center justify-content-between px-4 text-start"
                style={{ fontSize: '1.1rem', borderRadius: '14px' }}
              >
                <span>🎉 <strong>Receitas Feitas</strong></span>
                <span>&rarr;</span>
              </button>

              <button
                type="button"
                data-testid="profile-favorite-btn"
                onClick={ () => this.setRoute('/receitas-favoritas') }
                className="filter-button orange w-100 py-3 d-flex align-items-center justify-content-between px-4 text-start"
                style={{ fontSize: '1.1rem', borderRadius: '14px' }}
              >
                <span>❤️ <strong>Receitas Favoritas</strong></span>
                <span>&rarr;</span>
              </button>

              <button
                type="button"
                data-testid="profile-logout-btn"
                onClick={ () => {
                  localStorage.clear();
                  setEmail('');
                  this.setRoute('/');
                } }
                className="filter-button w-100 py-3 d-flex align-items-center justify-content-between px-4 text-start mt-2"
                style={{ fontSize: '1.1rem', borderRadius: '14px', background: '#FFF0F0', color: '#D32F2F', border: '1px solid #FFCDD2' }}
              >
                <span>🚪 <strong>Sair da Conta</strong></span>
                <span>&rarr;</span>
              </button>
            </div>
          </div>
        </Container>
        <Footer className="footer orange" />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  email: state.user ? state.user.email : '',
});

const mapDispatchToProps = (dispatch) => ({
  setEmail: (email) => dispatch(login(email)),
});

Perfil.propTypes = {
  email: PropTypes.string,
  setEmail: PropTypes.func.isRequired,
};

Perfil.defaultProps = {
  email: '',
};

export default connect(mapStateToProps, mapDispatchToProps)(Perfil);
